import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { Detview } from './components/detview';

const DetallesComisionesPage: FC = () => {
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: '/configuracion/comisiones',
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'comisiones',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Detalle comisiones</PageTitle>
      <Detview/>
    </>
  );
};

export {DetallesComisionesPage}